import * as React from 'react';

const ArrowIcon = ({fillColor = '#2961fa'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.264}
    height={12.264}
    transform="rotate(180)">
    <path
      data-name="Path 528"
      d="M6.132 0 5.017 1.115l4.221 4.221H0v1.592h9.238l-4.221 4.221 1.115 1.115 6.132-6.132Z"
      fill={fillColor}
    />
  </svg>
);

export default ArrowIcon;
